import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CitySaintMaurDesFossesPage() {
  const data = citiesData.find((c) => c.slug === "saint-maur-des-fosses")!;
  return <CityPage data={data} />;
}
